export default {
  name: 'tagQuestion',
  uniqKey: '_id',
  crudMapping: {
    readMany: 'tagQuestions',
    readOne: 'tagQuestion',
    create: 'createTagQuestion',
    update: 'updateTagQuestion',
    // delete: 'deleteTagQuestion',
  },
  readManySchema: {
    jsonSchema: {
      type: 'object',
      properties: {
        title: {
          type: 'string',
        },
      },
    },
  },
  defaultSchema: {
    jsonSchema: {
      title: 'Tag Question',
      type: 'object',
      required: [
        'title',
        'question',
      ],
      properties: {
        title: {
          type: 'string',
        },
        question: {
          type: 'string',
        },
        tagIds: {
          type: 'array',
          items: {
            type: 'string',
          },
        },
      },
    },
    uiSchema: {
      tagIds: {
        'ui:field': 'hasManyField',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/schemas/admin/tagQuestion.js